import { Checkbox, Divider, Select, Table } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'

import * as R from 'ramda'
import React from 'react'

import { rowParDiffClassName } from '../../shared/columns'
import { Flag } from '../countries'

import { TeamResultItemProps } from './TeamResultsList'

import './TeamResultItem.css'

export const TeamResultItem: React.FunctionComponent<TeamResultItemProps> = ({
  teamResult,
  tournament,
  admin,
  setPlayoffFlag,
  setPlayoffRank,
  largeFlag,
}) => {
  const getLastRoundPlayoffFlag = R.path<boolean>(['lastRoundPlayoffFlag', 'teams'])

  const data = teamResult.players.map((player) => ({
    key: player.id,
    ...player,
    ...teamResult,
  }))

  const categoryId = 'teams'

  const columns: FIXME = [
    {
      title: 'RANK',
      width: '1em',
      dataIndex: 'rank',
      render: (value, row, index) => {
        return {
          children: <span>{typeof value === 'number' ? `${value}.` : value}</span>,
          props: {
            rowSpan: index === 0 ? teamResult.players.length : 0,
          },
        }
      },
    },
    {
      title: teamResult.nationality,
      width: largeFlag ? '155px' : '4em',
      dataIndex: 'nationality',
      className: largeFlag ? 'largeFlagColumn' : '',
      render: (value, row, index) => {
        return {
          children: <Flag iso2={value} />,
          props: {
            rowSpan: index === 0 ? teamResult.players.length : 0,
          },
        }
      },
    },
    {
      title: `${teamResult.teamName}`,
      key: 'Player',
      render: (value, row, index) => `${row.firstName} ${row.lastName}`,
    },
    ...R.range(1, tournament.rounds + 1).map((round) => ({
      title: round,
      width: '3em',
      render: (value, record) => R.path(['results', round, 'score'], record),
    })),
    {
      title: 'SUM',
      width: '3em',
      dataIndex: 'score',
      className: 'ResultsCol--sum',
      render: (value, row, index) => {
        return {
          children: value,
          props: {
            rowSpan: index === 0 ? teamResult.players.length : 0,
          },
        }
      },
    },
    {
      title: 'PAR',
      width: '3em',
      dataIndex: 'par',
      className: 'ResultsCol--par',
      render: (value, row, index) => {
        return {
          children: teamResult.parDiff,
          props: {
            rowSpan: index === 0 ? teamResult.players.length : 0,
          },
        }
      },
    },
    ...(admin
      ? [
          {
            title: 'Playoff',
            render: (text, record, index) => {
              const playoffFlagOnChangeHandler = (event: CheckboxChangeEvent) => {
                event.preventDefault()
                setPlayoffFlag(record.playoffRankTeams)(event.target.checked)
              }

              return {
                children: (record.playoffRankTeams.length > 1 ||
                  getLastRoundPlayoffFlag(record)) && (
                  <Checkbox
                    checked={getLastRoundPlayoffFlag(record)}
                    onChange={playoffFlagOnChangeHandler}
                  />
                ),
                props: {
                  rowSpan: index === 0 ? teamResult.players.length : 0,
                },
              }
            },
            width: '2em',
          },
          {
            title: 'Rank',
            render: (text, record, index) => {
              const playoffRankChangeHandler = (value: any) => {
                setPlayoffRank(record.id)(value)
              }

              return {
                children: getLastRoundPlayoffFlag(record) && (
                  <Select
                    size="small"
                    value={R.path(['lastRoundPlayoffRank', categoryId], record)}
                    onChange={playoffRankChangeHandler}>
                    {R.range(1, record.playoffRankTeams.length + 1).map((playoffRank) => (
                      <Select.Option key={playoffRank} value={playoffRank}>
                        {playoffRank}
                      </Select.Option>
                    ))}
                  </Select>
                ),
                props: {
                  rowSpan: index === 0 ? teamResult.players.length : 0,
                },
              }
            },
            width: '2em',
          },
        ]
      : []),
    {
      title: 'Notes',
      width: '4em',
      render: (text, record, index) => {
        const dnfFlag = record.isDisqualified && 'DNF'
        const penaltyFlag = R.pathOr(0, ['penalties'], record) > 0 && `⚠️ ${record.penalties}`
        const playoffFlag = getLastRoundPlayoffFlag(record) && 'P'

        const flags = [dnfFlag, penaltyFlag, playoffFlag].filter(Boolean) as FIXME

        return {
          children: R.intersperse(<Divider type="vertical" />, flags),
          props: {
            rowSpan: index === 0 ? teamResult.players.length : 0,
          },
        }
      },
    },
  ]

  const rowClassName = (record: any /* TODO */, index: number) =>
    [rowParDiffClassName(record)].join(' ')

  return (
    <Table
      bordered
      className="TeamResultItem"
      dataSource={data}
      columns={columns}
      pagination={false}
      rowClassName={rowClassName}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/tournament/TeamResultItem.tsx